import React, { useState, useRef } from 'react';
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import { Button } from 'reactstrap';

const CreateKML = () => {
    const [polygons, setPolygons] = useState([]);
    const featureGroupRef = useRef();

    const onCreated = (e) => {
        const layer = e.layer;
        const coordinates = layer.getLatLngs()[0].map(latLng => ({
            lat: latLng.lat,
            lng: latLng.lng
        }));
        setPolygons([...polygons, coordinates]);
    };

    const generateKML = () => {
        let kml = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
    <Document>
        <Style id="polygonStyle">
            <PolyStyle>
                <color>4dff0000</color> <!-- Format: aabbggrr where aa=opacity(4d=30%), ff0000=blue color -->
                <outline>1</outline>
                <fill>1</fill>
            </PolyStyle>
            <LineStyle>
                <color>ff0000ff</color> <!-- Solid red outline -->
                <width>2</width>
            </LineStyle>
        </Style>`;

        polygons.forEach((polygon, index) => {
            const closedPolygon = [...polygon, polygon[0]];
            kml += `
        <Placemark>
            <name>Polygon ${index + 1}</name>
            <styleUrl>#polygonStyle</styleUrl>
            <Polygon>
                <outerBoundaryIs>
                    <LinearRing>
                        <coordinates>
                            ${closedPolygon.map(coord => `${coord.lng},${coord.lat},0`).join(' ')}
                        </coordinates>
                    </LinearRing>
                </outerBoundaryIs>
            </Polygon>
        </Placemark>`;
        });

        kml += `
    </Document>
</kml>`;

        return kml;
    };

    const downloadKML = () => {
        if (polygons.length === 0) {
            alert('No polygons drawn!');
            return;
        }

        const kml = generateKML();
        const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'polygons.kml';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const clearAll = () => {
        setPolygons([]);
        if (featureGroupRef.current) {
            const featureGroup = featureGroupRef.current;
            featureGroup.clearLayers();
        }
    };

    return (
        <div className="map-container">
            <div className="map-controls">
                <Button color="primary" className='m-2' onClick={downloadKML}>Download KML</Button>
                <Button color="primary"  onClick={clearAll}>New</Button>
            </div>
            <MapContainer
                center={[19.9615, 79.2961]}
                zoom={10}
                style={{ height: '70vh', width: '100%' }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <FeatureGroup ref={featureGroupRef}>
                    <EditControl
                        position="topright"
                        onCreated={onCreated}
                        draw={{
                            rectangle: false,
                            circle: false,
                            circlemarker: false,
                            marker: false,
                            polyline: false
                        }}
                    />
                </FeatureGroup>
            </MapContainer>
        </div>
    );
};

export default CreateKML;
